export enum InvoiceStatus {
    CreatedSuccess = 'CreatedSuccess',
    InProgress = 'InProgress',
    CreatedWithWarnings = 'CreatedWithWarnings',
    Failed = 'Failed',
}

export interface ICustomerInvoice {
    id: number,
    quickBookInvoiceId: string,
    dueDate: Date,
    generatedBy: string,
    createDate: Date;
    service: string; // similar to BillingMode
    invoiceUrl: string;
    externalAttachmentId: string;
    attachmentFileName: string;
    statusDescription: string;
    status: InvoiceStatus
}

export interface IQuickBookInvoice {
    id: string,
    customerName: string,
    totalAmount: number,
    invoiceDate: string,
    dueDate: string,
    salesTerm: string,
    notes: string
}
export interface ICreateCustomerInvoice {
    dueDate: string;
    comment?: string;
    salesTermId?: string;
}
